import { ISymbolsHandler } from '../../getSymbolsChecks.types';

export const handlerOpenSquareBracket: ISymbolsHandler = (opts) => {
  const { index, symbolMatches } = opts;

  symbolMatches['['].push({
    start: index,
    end: index + 1,
  });
};
